export const navLinks = [
  { label: 'Accueil', to: '/' },
  { label: 'À propos', to: '/a-propos' },
  { label: 'Services', to: '/services' },
  { label: 'Secteurs', to: '/secteurs' },
  { label: 'Méthode', to: '/methode' },
  { label: 'Références', to: '/references' },
  { label: 'Blog', to: '/blog' },
];

export const contactInfo = {
  email: 'contact@lprocure-consulting.fr',
  phone: '+33 6 12 34 56 78',
  location: 'Paris & Île-de-France',
  coverage: 'Missions en France et à l’international',
  linkedin: 'https://www.linkedin.com/',
};
